import React, { useCallback, useState } from 'react';
import {Formik, FormikHelpers} from 'formik';
import './styles.css';
import { Values, cpfMask, initialValues, validationSchema } from './data';
import { contactService } from '../../services/contact';
import { AxiosError } from 'axios';

export const Form = () => {

  const [sent, setSent] = useState(false);
  

  const handleSubmit = useCallback(async (values: Values, formilHelpers: FormikHelpers<any>) => {
    // await new Promise((resolve) => setTimeout(resolve, 2000));

    try {
      const queryString = window.location.search;

      const urlParams = new URLSearchParams(queryString);

      const companyReferral = urlParams.get('your-company-referral') || '';
      const userReferred = urlParams.get('your-user-referred') || '';
      const gclid = urlParams.get('gclid') || '';
      const fbclid = urlParams.get('fbclid') || '';
      const wbraid = urlParams.get('wbraid') || '';
      const url = window.location.href || '';
      const utmSource = urlParams.get('utm_source') || '';
      const utmMedium = urlParams.get('utm_medium') || '';

      await contactService.send({
        ...values,
        companyReferral,
        userReferred,
        gclid,
        fbclid,
        url,
        utmSource,
        utmMedium,
        wbraid,
      });

      setSent(true);

      window.location.href = '/obrigado';

    } catch (error: any) {

      if(error instanceof AxiosError) {
        formilHelpers.setFieldError('_error', error.response?.data?.message || 'Houve um error desconhecido. Tente novamente mais tarde!');
        return;
      }

      formilHelpers.setFieldError('_error', 'Houve um error desconhecido. Tente novamente mais tarde!')
    }


  }, []);

  return <div className="form-container">
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue}) => (
        <form action="input-name" onSubmit={handleSubmit}>
          <div className='form-field'>
            <label htmlFor="input-name">
              <input 
                type="text" 
                required
                className="input-text" 
                id="input-name" 
                name="name" 
                placeholder="Nome *" 
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
                disabled={isSubmitting || sent}
              />
            </label>
            {errors.name && touched.name ? (
             <div className="form-error">{errors.name}</div>
            ) : null}
          </div>

          <div className='form-field'>
            <label htmlFor="input-cpf">
              <input 
                type="text" 
                required
                className="input-text" 
                id="input-cpf" 
                name="cpf" 
                placeholder="CPF *" 
                // onChange={handleChange}
                onChange={(e) => setFieldValue('cpf', cpfMask(e.target.value || ''))}
                onBlur={handleBlur}
                value={values.cpf}
                disabled={isSubmitting || sent}
              />
            </label>
            {errors.cpf && touched.cpf ? (
             <div className="form-error">{errors.cpf}</div>
            ) : null}
          </div>

          <div className='form-field'>
            <label htmlFor="input-email">
              <input 
                type="email" 
                required
                className="input-text" 
                id="input-email" 
                name="email" 
                placeholder="E-mail *" 
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                disabled={isSubmitting || sent}
              />
            </label>
            {errors.email && touched.email ? (
             <div className="form-error">{errors.email}</div>
            ) : null}
          </div>

          <div className='form-field'>
            <label htmlFor="input-phone">
              <input 
                type="tel" 
                required
                className="input-text" 
                id="input-phone" 
                name="phone" 
                placeholder="Celular / WhatsApp *" 
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.phone}
                disabled={isSubmitting || sent}
              />
            </label>
            {errors.phone && touched.phone ? (
             <div className="form-error">{errors.phone}</div>
            ) : null}
          </div>

          <div className='form-field'>

            {errors._error && touched._error ? (
             <div className="form-error mb">{errors._error}</div>
            ) : null}

            <input 
              type="submit" 
              className="input-submit" 
              value={isSubmitting ? 'Aguarde...' : 'Enviar'} 
              disabled={isSubmitting || sent}
            />
          </div>
        </form>
      )}
    </Formik>
    
  </div>;
}